//@flow
import { connect } from 'react-redux';
import NewPaymentMeanPage from '../../../components/payments/NewPaymentMeanPage';
import { addPaymentMeanDuringActivate } from '../../../modules/Payment';

const mapStateToProps = state => ({
  cardRegistrationIssuePage: 'cardRegistrationIssueDuringActivate',
});

const mapDispatchToProps = {
  addPaymentMean: addPaymentMeanDuringActivate,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPaymentMeanPage);
